import(/* webpackMode: "eager" */ "/opt/buildhome/repo/packages/web/src/app/global-error.tsx");
